import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

/**
 * GET /tasks/my — list tasks owned by or assigned to the current user.
 */
export const getMyTasks = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/tasks/my`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

/**
 * GET /tasks — list all tasks within company/BU scope.
 */
export const listTasks = async (params = {}, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/tasks`, {
    params,
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

/**
 * POST /tasks — create a new task.
 */
export const createTask = async (data, options = {}) => {
  const { buId } = options || {};
  const response = await axios.post(`${BASE_URL}/tasks`, data, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

/**
 * GET /tasks/:id — get a single task.
 */
export const getTask = async (taskId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.get(`${BASE_URL}/tasks/${taskId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

/**
 * PATCH /tasks/:id — update a task.
 */
export const updateTask = async (taskId, data, options = {}) => {
  const { buId } = options || {};
  const response = await axios.patch(`${BASE_URL}/tasks/${taskId}`, data, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};

/**
 * DELETE /tasks/:id — delete a task.
 */
export const deleteTask = async (taskId, options = {}) => {
  const { buId } = options || {};
  const response = await axios.delete(`${BASE_URL}/tasks/${taskId}`, {
    ...(buId ? { headers: { "X-Business-Unit-Id": buId } } : {}),
  });
  return response.data;
};
